module.exports = __webpack_public_path__ + "img/dm.08cd8c03.svg";